module.exports = __webpack_public_path__ + "static/media/Getty_Images_1188457330_desktop.5d9f29ee.jpg";